import { IRegion } from './../_models/account/IRegion';
import { RegionService } from './../shared/services/region.service';
import { ApplicationStateService } from './../shared/services/application-state.service';
import { Component, OnInit } from '@angular/core';
import { RegionProfileService } from './region-profile.service';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css']
})
export class RegionComponent implements OnInit {

  public sidebar = 'g-sidenav-pinned g-sidenav-show';
  public isCollapsed = false;
  constructor(
    private applicationStateService: ApplicationStateService,
    private regionService: RegionService,
    private regionProfileService: RegionProfileService,) { }

  ngOnInit(): void {
    if (this.applicationStateService.getIsMobileResolution()) {
      this.sidebar = 'g-sidenav-hidden';
    }

    this.getRegion();
  }

  show() {
    if (this.isCollapsed && !this.applicationStateService.getIsMobileResolution()) {
      this.sidebar = 'g-sidenav-show';
    }
  }

  hide() {
    if (this.isCollapsed && !this.applicationStateService.getIsMobileResolution()) {
      this.sidebar = 'g-sidenav-hidden';
    }

  }

  collapsed() {
    this.isCollapsed = !this.isCollapsed;
    if (this.applicationStateService.getIsMobileResolution()) {
      if (!this.isCollapsed) {
        this.sidebar = 'g-sidenav-hidden';
      }
      else {
        this.sidebar = 'g-sidenav-pinned g-sidenav-show';
      }
    }
    else {
      if (!this.isCollapsed) {
        this.sidebar = 'g-sidenav-pinned g-sidenav-show';
      }
      else {
        this.sidebar = 'g-sidenav-hidden';
      }
    }
  }

  showSearch() {
    this.sidebar = 'g-sidenav-hidden g-navbar-search-show g-navbar-search-shown';
  }

  closeSearch() {
    this.sidebar = 'g-sidenav-hidden';
  }

  getRegion() {
    this.regionService.logged().subscribe((response: IRegion) => {
      if (response) {
        this.regionProfileService.changeProfile(response);
      }
    });
  }

}
